import styled from "styled-components";

const FormRow = styled.div`
    display: flex;
    justify-content: space-between;
    margin-bottom: 1em;
`;

export default FormRow;
